import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <hr />
    <p>{`© 2022, `}<a parentName="p" {...{
        "href": "https://appsolut.at"
      }}>{`appsolut software gmbh`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      